import { axios } from "~/plugins/request"
export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    //管理员保存消息
    adminSaveMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminSaveMessage', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //管理员获取消息列表
    adminSelectMessages({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminSelectMessages', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //管理员查看一条消息
    adminGetMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminGetMessage', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //管理员编辑消息
    adminUpdateMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminUpdateMessage', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //管理员发送消息
    adminSendMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminSendMessage', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //管理员发送保存消息
    adminSendEditedMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/adminSendEditedMessage', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //用户获取未读消息总数
    getMessageNoticeCount({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get('/message/getMessageNoticeCount', {params})
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //用户获取未读消息总数
    selectMessages({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/selectMessages', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selectUserId({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post('/message/selectUserId', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selectMessagesService({ commit }, params) {      //初始化消息列表/message/selectMessagesService
        return new Promise((resolve, reject) => {
            axios.post('/message/selectMessagesService', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    updateMessagesServiceStatus({ commit }, params) {      //初始化消息列表/message/updateMessagesServiceStatus
        return new Promise((resolve, reject) => {
            axios.post('/message/updateMessagesServiceStatus', params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //用户获取未读消息总数
    messageClear({ commit }, params) {
      return new Promise((resolve, reject) => {
          axios.get('/message/messageClear', {params})
              .then(response => {
                  resolve(response)
              })
              .catch(error => {
                  reject(error)
              })
      })
  },
}